import {Component, inject, OnInit} from '@angular/core';
import {Button} from 'primeng/button';
import {Card} from 'primeng/card';
import {InfoTextComponent} from '../../../../../shared/common/info-text/info-text.component';
import {LoadingComponent} from '../../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../../components/generic/message/message.component';
import {PlayerProfileAvatarComponent} from '../../../player-profile-avatar/player-profile-avatar.component';
import {
  PlayerProfileMessagesListComponent
} from '../../player-profile-messages/player-profile-messages-list/player-profile-messages-list.component';
import {
  PlayerProfileRegistrationPinComponent
} from '../../player-profile-account/player-profile-account-data/player-profile-registration-pin/player-profile-registration-pin.component';
import {
  PlayerProfileSettingsPushNotificationComponent
} from '../../../player-profile-settings-dialog/player-profile-settings-push-notification/player-profile-settings-push-notification.component';
import {
  PlayerProfileStatisticsViewComponent
} from '../player-profile-statistics-view/player-profile-statistics-view.component';
import {RouterLink} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ViewService} from '../../../../../shared/service/view.service';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {ErrorType} from '../../../../../../model/error-type';
import {PlayerDashboard} from '../../../../model/player-dashboard';
import {HelpService} from '../../../../../shared/service/help.service';
import {Divider} from 'primeng/divider';
import {UpdateHistoryComponent} from '../../../../../backend/home/update-history/update-history.component';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from '../../../../../../../environments/environment';
import {
  PlayerProfileReportPictureDialogComponent
} from '../../../common/player-profile-report-picture-dialog/player-profile-report-picture-dialog.component';
import {
  PLAYER_PROFILE_FEATURES
} from '../../../player-profile-register/features/player-profile-features/player-profile-features.component';
import {NgTemplateOutlet} from '@angular/common';
import {
  PlayerProfileFeaturesDialogComponent
} from '../../../player-profile-register/features/player-profile-features-dialog/player-profile-features-dialog.component';

@Component({
  selector: 'app-player-profile-dashboard-home',
  imports: [
    Button,
    Card,
    InfoTextComponent,
    LoadingComponent,
    MessageComponent,
    PlayerProfileAvatarComponent,
    PlayerProfileMessagesListComponent,
    PlayerProfileRegistrationPinComponent,
    PlayerProfileSettingsPushNotificationComponent,
    PlayerProfileStatisticsViewComponent,
    RouterLink,
    TranslatePipe,
    Divider,
    NgTemplateOutlet
  ],
  templateUrl: './player-profile-dashboard-home.component.html',
  styleUrl: './player-profile-dashboard-home.component.scss'
})
export class PlayerProfileDashboardHomeComponent  implements OnInit
{
  public view = inject(ViewService);
  public playerProfileService = inject(PlayerProfileService);
  private restErrorHelper = inject(RestErrorHelper);
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);

  isLoading: boolean;
  errorMsg: ErrorType;
  data: PlayerDashboard;
  isProduction: boolean;

  newFeatures: any[];

  ngOnInit(): void
  {
    this.loadData();
    this.isProduction = environment.production;

    this.newFeatures = PLAYER_PROFILE_FEATURES.filter(f => f.new);
  }

  private loadData(): void
  {
    this.isLoading = true;
    this.errorMsg = undefined;
    this.data = undefined;
    this.playerProfileService.loadDashboardData().subscribe({
      next: response =>
      {
        console.log('PlayerProfile Dashboard-Daten geladen', response);
        this.isLoading = false;
        this.data = response;
      },
      error: error =>
      {
        this.isLoading = false;
        console.log('Fehler bei "loadData"', error);
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  public showHelpRegistrationPin(): void
  {
    HelpService.helpPlayerProfileRegistrationCode();
  }

  public showUpdateHistory(): void
  {
    UpdateHistoryComponent.showDialog(this.dialogService, this.translate,
      'https://2k-dartsoftware.freshdesk.com/support/solutions/articles/103000404141');
  }

  public reportPicture(): void
  {
    PlayerProfileReportPictureDialogComponent.openDialog(this.dialogService, this.data.playerProfile, this.translate);
  }

  public openPlayerProfileFeatures(): void
  {
    PlayerProfileFeaturesDialogComponent.showDialog(this.dialogService, this.translate);
  }
}
